import React from 'react'

import {
  getAIClientDownloadURL,
  markAIClientUpgradeModalHandled
} from '../../../utils/aiClientUpgrade'
import upgradeBg from './assets/upgrade_bg.png'
import upgradeIllustration from './assets/upgrade_illustration.png'
import iconClose from './assets/icon_close.svg'
import './index.scss'

interface Props {
  visible: boolean
  onClose: () => void
}

/**
 * AI 版客户端老版本升级引导弹窗（设计稿 node 1633:491）。
 * 展示条件由 utils/aiClientUpgrade 的 shouldShowAIClientUpgradeModal 判定，
 * 本组件负责呈现、下载跳转，以及「处理过」的记账——点关闭或点下载都算
 * 处理，当天不再弹；只弹出没点按钮不记账。
 */
const AIClientUpgradeModal: React.FC<Props> = ({ visible, onClose }) => {
  if (!visible) return null

  const handleClose = () => {
    markAIClientUpgradeModalHandled()
    onClose()
  }

  const handleDownload = () => {
    markAIClientUpgradeModalHandled()
    // 必须用 window.open：客户端对 window.open 统一走 setWindowOpenHandler →
    // shell.openExternal，由系统浏览器完成下载；同帧导航到站外地址会被客户端
    // 拦成 chrome-error 错误页，内嵌页直接白屏（2026-08-26 实测）。
    window.open(getAIClientDownloadURL())
  }

  return (
    <div className="ai-client-upgrade-modal">
      <div className="ai-client-upgrade-modal__card">
        <div className="ai-client-upgrade-modal__bg">
          <img src={upgradeBg} alt="" />
        </div>
        <button
          className="ai-client-upgrade-modal__close"
          onClick={handleClose}
          aria-label="关闭"
        >
          <img src={iconClose} alt="" />
        </button>
        <img
          className="ai-client-upgrade-modal__illustration"
          src={upgradeIllustration}
          alt=""
        />
        <h2 className="ai-client-upgrade-modal__title">“AI客户端”升级啦！</h2>
        <div className="ai-client-upgrade-modal__desc">
          <p>您当前的客户端版本较低，且无法自动更新。</p>
          <p>请手动下载并安装最新版，以正常使用新功能。</p>
        </div>
        <button
          className="ai-client-upgrade-modal__cta"
          onClick={handleDownload}
        >
          立即下载
        </button>
      </div>
    </div>
  )
}

export default AIClientUpgradeModal
